import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import AuthBootScreen from "./AuthBootScreen";
import { actsAsAgencyAdmin } from "../../utils/permissions";

export default function ProtectedRoute({ allowedRoles = [], requiredPermission = null }) {
  const { auth, isReady } = useAuth();
  const location = useLocation();
  const permissions = Array.isArray(auth?.user?.permissions)
    ? auth.user.permissions
    : Array.isArray(auth?.permissions)
      ? auth.permissions
      : [];

  if (!isReady) {
    return <AuthBootScreen />;
  }

  if (!auth?.isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (
    allowedRoles.length &&
    !allowedRoles.includes(auth?.user?.role) &&
    !(allowedRoles.includes("REPO_ADMIN") && actsAsAgencyAdmin(auth))
  ) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  if (
    requiredPermission &&
    auth?.user?.role !== "REPO_ADMIN"
  ) {
    const keys = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    if (!keys.some((key) => permissions.includes(key))) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  return <Outlet />;
}
